import React from "react";
import { useTranslation } from "src/context/Translations/context";
import IComponentSelect from "react-common-components/dist/components/Select/interface";
import Select from "src/components/Select";

const LovDecimalPlaces: React.FC<Omit<IComponentSelect,"options">> = ({
	name,
	control,
	label,
	defaultValue,	
	...rest
}) => {
	const { translate} = useTranslation();
	return (
		<Select
			control={control}
			name={name}
			label={label||translate("Casas decimais")}
			defaultValue={defaultValue||"2"}
			options={[
				{ value: "0", label: "0" },
				{ value: "1", label: "1" },
				{ value: "2", label: "2" },
				{ value: "3", label: "3" },
				{ value: "4", label: "4" },
				{ value: "5", label: "5" }
			]}
			{...rest}
		/>
	);
};

export default LovDecimalPlaces;
